<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
      <!--begin::sidebar-->
      <sidebar-component classMenu="BranchIndex"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <h4 style="margin-right: 15px; margin-top: 5px" class="float-start">{{ $t("trafficViolation") }}</h4>

                  <div class="float-start" style="margin-right: 15px;">
                    <date-range-picker style="width: 100%" @change="filterDateRange"
                        control-container-class="form-control" :locale-data="locale"
                        v-model="dateFilter" :opens="opens" :singleDatePicker="false"
                        :timePicker24Hour="true" :timePicker="true" :showWeekNumbers="false">
                    </date-range-picker>
                   
                  </div>

                  <div class="float-start">
                    <button
                      class="btn btn-warning float-end btn-sm"
                      style="margin-right: 5px"
                      @click.prevent="filterDateRange"
                    >
                      Go
                    </button>
                  </div>


                  <button
                     v-if="permision_role.method_create"
                    class="btn btn-primary float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="createData()"
                  >
                    <i class="link-icon" data-feather="plus"></i>
                    {{ $t("createNew") }}
                  </button>

                  <button
                    class="btn btn-warning float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()"
                  >
                     <i class="link-icon" data-feather="upload"></i>
                    Report
                  </button>
                  

                  <!-- <button
                    v-if="permision_role.method_read"
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()"
                  >
                     <i class="link-icon" data-feather="download"></i>
                    {{ $t("downloadData") }} .xlsx
                  </button> -->
                </div>

                <div class="card-body">
                  <vue-good-table
                    title="list-of-gps-erorrs-reporting"
                    mode="remote"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-selected-rows-change="selectionChanged"
                    :select-options="{
                        enabled: true,
                        selectOnCheckboxOnly: true,
                        selectionText: $t('data_selected'),
                        clearSelectionText: $t('clear'),
                    }"
                    :sort-options="{
                      enabled: false,
                    }"
                    :totalRows="totalRecords"
                    :line-numbers="true"
                    :isLoading.sync="isLoading"
                    :pagination-options="{
                      enabled: true,
                    }"
                    :filterOptions="{
                      enabled: false,
                    }"
                    :rows="rowsTable"
                    :columns="columnsOrder"
                  >

                  <div slot="selected-row-actions">
                    <button class="btn btn-success btn-xs" style="margin-right:20px;" @click="updateStatusAll('PENDING')"> <i
                        class="mdi mdi-recycle"></i> Pending </button>

                    <button class="btn btn-warning btn-xs" @click="updateStatusAll('CLOSED')"><i class="mdi mdi-close"></i>Close </button>
                  </div>

                    <!-- <div slot="table-actions">
                      <div class="vgt-clearfix">
                        <button class="btn btn-success btn-xs" style="font-size: 10pt; margin-top:-7px" @click.prevent="TambahFormModal()">
                          <i class="link-icon" data-feather="plus"></i>
                          {{ $t("createNew") }}
                        </button>
                      </div>
                    </div> -->
                    <template slot="table-row" slot-scope="props">
                      <!-- <span v-if="props.selectable">
                        {{props.selectable}}
                      </span> -->
                      <span v-if="props.column.field == 'control'">
                        <a
                        v-if="permision_role.method_read"
                          href="#"
                          title="Detail"
                          @click.prevent="detailData(props.index, props.row)"
                        >
                          <i class="mdi mdi-eye" style="font-size: 16px"></i>
                        </a> 
                        
                        <a
                              href="#"
                              title="Edit"
                              v-if="permision_role.method_update"
                              @click.prevent="editData(props.index, props.row)"
                            >
                            <i class="mdi mdi-square-edit-outline" style="font-size: 16px"></i>
                            </a>
                       
              
                        <a
                          href="#"
                          title="Pending"
                          v-if="props.row.tv_status!='CLOSED'"
                          @click.prevent="updateStatus(props.index, props.row,'PENDING')"
                        >
                          <i class="mdi mdi-recycle" style="font-size: 16px"></i>
                        </a>

                        <a
                          href="#"
                          title="Closed"
                     
                          v-if="props.row.tv_status!='CLOSED' && permision_role.method_update"
                          :disabled="props.row.tv_status=='CLOSED'"
                          @click.prevent="updateStatus(props.index, props.row,'CLOSED')"
                        >
                          <i class="mdi mdi-close" style="font-size: 16px"></i>
                        </a>

                      </span>

                     
              
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from "vue2-daterange-picker";
import moment from 'moment';

export default {
  name: "TraffictViolationIndex",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DateRangePicker
  },
  data() {

    const startDate = moment().clone().startOf('month').format('YYYY-MM-DD'); // new Date();
    const endDate = new Date();
    return {
      filterDateRangeValue:false,
      opens: "center",
      listStatus:["Open","Close"],
      locale: {
                format: "yyyy-mm-dd",
            },
      dateFilter: {
                startDate,
                endDate,
            },
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role:[],
      langs: ["id", "en"],
      detailUser: [],
      detailDivisi: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      rowsTable: [],
        columnsOrder: [
        {
            label: "Status",
            field: "tv_status",
          },
        {
            label: "Vehicle No",
            field: "vehicle_no",
          },

          {
            label: "Category",
            field: "category",
          },

          {
            label: "Reason",
            field: "reason",
          },

          {
            label: "Location",
            field: "location",
          },

          {
            label: "Driver NMK",
            field: "driver_nmk",
          },

          {
            label: "Driver Name",
            field: "driver_name",
          },
          {
            label: "Driver Hp",
            field: "driver_hp",
          },
          {
            label: "Load ID",
            field: "load_number",
          },

          {
            label: "Date",
            field: "tv_date",
          },

          {
            label: "Result",
            field: "tv_result",
          },

         
  
          {
            label: "Control",
            field: "control",
          },
        ],
      rows: [],
      driver_tv_id:[],
    };
  },
  watch: {},
  methods: {

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.detailUser     = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'DriverTvController'){
          rolePermision = permision;
        }
      });

      if(!rolePermision.method_read){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },

    selectionChanged(ev) {
      // var rowsSelection = [];
      var rowsSelection = ev.selectedRows;
    
      rowsSelection.forEach((item) => {
        if(item.tv_status!='CLOSED'){
          
          item.vgtSelected=true;
          this.driver_tv_id.push(item.driver_tv_id);
        }else{
          item.vgtSelected=false;
        }
        
        // this.transport_order_header_ids.push(item.transport_order_header_id);
        // if(item.order_status=='NEW'){
        //   this.error('Order No:'+item.order_status+' Status Not Submited, because status order not NEW or SUBMITED');
        // }else{

        // }

      });

      // console.log(this.dri);

    },

   

    updateStatusAll(status){
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          //this.loadingSubmiting();
          this.loading();
          let data = {
            driver_tv_ids: this.driver_tv_id,
            tv_status:status
          }
          const baseURI =
            this.$settings.endPointCt + "driver-tv/update-status";
          this.$http
            .patch(baseURI, data)
            .then((response) => {
              //this.loading();
              if (response.data.status === 200) {
                // response.data.datas.messages.forEach((item) => {
                //   this.success(item);
                // });

                this.success(response.data.datas.messages);
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {

                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.error(error.response.data.errors.message);
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });

    },

    downloadData() {
      const baseURI = this.$settings.endPointCt + "/driver-tv";
      var start= moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD');
      var end= moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD');
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";
      var url=`?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&download=download`;
      if(this.filterDateRangeValue==true){
        url=`?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&start=${start}&end=${end}&download=download`;
      }

      //var columnFilters = this.serverParams.columnFilters;


      return this.$http
        .get(
          baseURI +
            url,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
         
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    // downloadData() {
    //   this.fade(true);
    //   var baseURI = this.$settings.endPoint + "/user/download";
    //   var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
    //   var columnFilters = this.serverParams.columnFilters;
    //   var role = columnFilters["role.name"];
    //   var company_code = columnFilters["company_detail.code"];

    //   var sendData = {
    //     username: this.serverParams.columnFilters.username,
    //     name: this.serverParams.columnFilters.name,
    //     email: this.serverParams.columnFilters.email,
    //     level: this.serverParams.columnFilters.level,
    //     status: this.serverParams.columnFilters.status,
    //     role:role,
    //     company_code: company_code,
    //     file_name: "download_" + CurrentDate + ".xlsx",
    //   };
    //   this.$http({
    //     url: baseURI,
    //     method: "GET",
    //     data: sendData,
    //     responseType: "blob",
    //   })
    //     .then((response) => {
    //       this.errors = [];
    //       var filename = sendData.file_name;

    //       var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    //       var fileLink = document.createElement("a");

    //       fileLink.href = fileURL;
    //       fileLink.setAttribute("download", filename);
    //       document.body.appendChild(fileLink);
    //       fileLink.click();
    //       this.fade(false);
    //     })
    //     .catch((error) => {
    //       if (error.response) {
    //         if (error.response.status === 422) {
    //           this.errors = { message: ["File Not Found"] };
    //           this.error("File Not Found");
    //         } else if (error.response.status === 500) {
    //           this.$router.push("/server-error");
    //         } else {
    //           this.$router.push("/page-not-found");
    //         }
    //       }
    //     });
    // },
    createData() {
      window.location.href = "/traffict-violation/add";
    },

    uploadData(){
      window.location.href = "/branch/upload";
    },

    editData(index, row) {
      var params = this.$onRandom(row.driver_tv_id);
      window.location.href = "/traffict-violation/edit/" + params;
    },

    detailData(index, row) {
      var params = this.$onRandom(row.driver_tv_id);
      window.location.href = "/traffict-violation/detail/" + params;
    },

    updateStatus(index, row, status) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: 'Update status to '+status,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            driver_tv_ids:[row.driver_tv_id],
            tv_status: status,
          };
          const baseURI =
            this.$settings.endPointCt + "driver-tv/update-status/";
          this.$http
            .patch(baseURI, formData)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },

    // load items is what brings back the rows from server
    loadItems() {
      const baseURI = this.$settings.endPointCt + "driver-tv";

      //var columnFilters = this.serverParams.columnFilters;
      this.isLoading = true;
      return this.$http
        .get(
           baseURI +
         `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}`,
          { timeout: 10000 }
        )
        .then((response) => {
          this.isLoading = false;
          //this.rowsTable = response.data.datas.data;
          this.totalRecords = response.data.datas.total;

          this.rowsTable =[];
          var datas=response.data.datas.data;
          datas.forEach((value)=>{
            if(value.tv_status=='CLOSED'){
              value.vgtDisabled=true;
              value.vgtSelected=false;
            }
            this.rowsTable.push(value);
          });
        }).catch(error => {
           
          if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
          }else{

            if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else if (error.response.status === 401) {
                  this.$router.push("/authorized-error");
              }else{
                  this.$router.push('/page-not-found');
              }
            }

          }
        });
    },


    filterDateRange(){
          var start= moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD');
          var end= moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD');
          this.filterDateRangeValue=true;
          const baseURI = this.$settings.endPointCt + "driver-tv";

          this.isLoading = true;
          return this.$http
            .get(
              baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&start=${start}&end=${end}`,
              { timeout: 10000 }
            )
            .then((response) => {
              this.isLoading = false;
              this.rowsTable = response.data.datas.data;
              this.totalRecords = response.data.datas.total;
            }).catch(error => {
              
              if(error.code == "ECONNABORTED"){
                this.error(this.$t("check_internet_connection_txt"));
                
              }else{

                if (error.response) {
                  if(error.response.status === 422) {
                          this.errors = error.response.data.errors;
                          this.resultError(error.response.data.errors);
                  }else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                  }else if (error.response.status === 401) {
                      this.$router.push("/authorized-error");
                  }else{
                      this.$router.push('/page-not-found');
                  }
                }

              }
            });

    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },


    logout() {
      this.$logoutUser();
      this.$router.push("/");
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.loadItems();
    this.fetchIt();
    this.loading();
  },
};
</script>
<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}

.blur-content{
  filter: blur(5px); 
  pointer-events: none;
  
}
</style>